import {
    AdminGroupSaleStatus,
    AdminMarketplaceType,
    AdminOrderPaymentType,
    AdminPalletOrderAttachmentType,
    AdminProductStatus,
    ProductConsistency,
} from '../../gen/api/models';

type marketplaceLabel = {
    label: string;
    key: AdminMarketplaceType;
};

export const marketplaceLabels: marketplaceLabel[] = [
    {label: 'Facebook', key: AdminMarketplaceType.MarketplaceTypeFacebook},
    {label: 'Ebay', key: AdminMarketplaceType.MarketplaceTypeEbay},
    {label: 'Offer Up', key: AdminMarketplaceType.MarketplaceTypeOfferUp},
    {label: 'Craigs List', key: AdminMarketplaceType.MarketplaceTypeCraigsList},
    {label: 'Marcari', key: AdminMarketplaceType.MarketplaceTypeMarcari},
    {label: 'Poshmark', key: AdminMarketplaceType.MarketplaceTypePoshmark},
    {label: 'Walmart', key: AdminMarketplaceType.MarketplaceTypeWalmart},
    {label: 'Depop', key: AdminMarketplaceType.MarketplaceTypeDepop},
];

type productStatus = {
    label: string;
    key: AdminProductStatus;
};

export const productStatuses: productStatus[] = [
    {label: 'Ready for Sale', key: AdminProductStatus.ProductStatusReadyForSale},
    {label: 'Active', key: AdminProductStatus.ProductStatusActive},
    {label: 'Draft', key: AdminProductStatus.ProductStatusDraft},
    {label: 'Reserved', key: AdminProductStatus.ProductStatusReserved},
    {label: 'Sold', key: AdminProductStatus.ProductStatusSold},
    {label: 'Took For Themself', key: AdminProductStatus.ProductStatusTookForThemself},
    {label: 'Need Review', key: AdminProductStatus.ProductStatusNeedReview},
];

type productConsistency = {
    label: string;
    key: ProductConsistency;
};

export const productConsistencies: productConsistency[] = [
    {label: 'New', key: ProductConsistency.ProductConsistencyNew},
    {label: 'Used', key: ProductConsistency.ProductConsistencyUsed},
    {label: 'Like New', key: ProductConsistency.ProductConsistencyLikeNew},
];

type orderPaymentType = {
    label: string;
    key: AdminOrderPaymentType;
};

export const orderPaymentTypes: orderPaymentType[] = [
    {label: 'Cash', key: AdminOrderPaymentType.OrderPaymentTypeCash},
    {label: 'Zelle', key: AdminOrderPaymentType.OrderPaymentTypeZelle},
    {label: 'PayPal', key: AdminOrderPaymentType.OrderPaymentTypePaypal},
    {label: 'Venmo', key: AdminOrderPaymentType.OrderPaymentTypeVenmo},
    {label: 'Marketplace', key: AdminOrderPaymentType.OrderPaymentTypeMarketplace},
];

type palletOrderAttachmentType = {
    label: string;
    key: AdminPalletOrderAttachmentType;
};

export const palletOrderAttachmentType: palletOrderAttachmentType[] = [
    {
        label: 'Amazon Manifest',
        key: AdminPalletOrderAttachmentType.PalletOrderAttachmentTypeAmazonManifest,
    },
];

type groupSaleStatusType = {
    label: string;
    key: AdminGroupSaleStatus;
};

export const groupSaleStatusTypes: groupSaleStatusType[] = [
    {label: 'Active', key: AdminGroupSaleStatus.GroupSaleStatusActive},
    {label: 'Inactive', key: AdminGroupSaleStatus.GroupSaleStatusInactive},
];
